import type React from 'react';
import { Box, Inline, Spread } from 'braid-design-system';
import { NavButton } from './NavButton';
import { PaginationButton } from './PaginationButton';

export const NavControlsWrapper = ({
  onLeftClick,
  onRightClick,
  onPaginationClick,
  isAnimating,
  currentChunk,
  totalChunks,
  children,
}: {
  onLeftClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onRightClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onPaginationClick: (
    e: React.MouseEvent<HTMLButtonElement>,
    chunkIndex: number,
  ) => void;
  isAnimating: boolean;
  currentChunk: number;
  totalChunks: number;
  children: React.ReactNode;
}) => {
  const isFirstChunk = currentChunk === 0;
  const isLastChunk = currentChunk + 1 === totalChunks;

  return (
    <Spread space="xxsmall" direction="vertical">
      <Box position="relative">
        <Box
          style={{
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            left: '0',
            right: '0',
            zIndex: 5,
          }}
        >
          <Spread space="large" direction="horizontal">
            <Box
              style={{
                left: '-24px',
                position: 'relative',
              }}
            >
              <NavButton
                direction="left"
                disabled={isFirstChunk || isAnimating}
                onClick={onLeftClick}
              />
            </Box>
            <Box
              style={{
                right: '-24px',
                position: 'relative',
              }}
            >
              <NavButton
                direction="right"
                disabled={isLastChunk || isAnimating}
                onClick={onRightClick}
              />
            </Box>
          </Spread>
        </Box>
        <Box>{children}</Box>
      </Box>
      <Inline space="none" align="center" alignY="center">
        {totalChunks > 1 &&
          Array.from({ length: totalChunks }, (_, i) => (
            <PaginationButton
              key={i}
              id={i}
              active={i === currentChunk}
              onClick={onPaginationClick}
            />
          ))}
      </Inline>
    </Spread>
  );
};
